<template>
  <component :is="tag" :class="classList">
    <slot></slot>
  </component>
</template>

<script lang="ts">
    
  import mixins from '../../mixins';

  export default mixins().extend({
    props: {
      fillHeight: { type: Boolean, default: false },
      fluid: { type: Boolean, default: false },
      tag: { type: String, default: 'div' },
    },
    computed: {
      classList() {
        return {
          'p-container': true,
          fluid: this.fluid,
          'fill-height': this.fillHeight,
        };
      },
    },
  });
</script>
